import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class AccountPopupMfaSetupComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('account') declare accountService: Service.Account;

	@action
	redirectToMfaSetup(): void {
		this.accountService.redirectToAccountAppProfile();
	}
	<template>
		<div class="content">
			<div class="mfa-header">
				<img src="/images/svg/popup_mfa_setup.svg" height="48" width="auto" alt />
				<h2>Two-factor authentication (2FA)</h2>
			</div>
			<hr />
			<div class="mfa-body">
				<p class="mfa-notice">
					<strong>
						Two-factor authentication (2FA) is required for your account.
					</strong>
				</p>
				<p>
					Your account administrator has set two-factor authentication (2FA) as required.
				</p>
				<p>
					You will be redirected to the account management application, to set up
					two-factor authentication for yourself.
				</p>
			</div>
			<div class="controls2 controls2--center">
				<SubmitButtonComponent
					@text="Set up two-factor authentication"
					@size="big"
					@onTrigger={{this.redirectToMfaSetup}}
				/>
			</div>
		</div>
	</template>
}
